/* The exercise table's own WAIT — the shape of the rows it is about to be.
 *
 * The centred box the four sentences stand in, and the two buttons under them, are
 * `shared/ui/listState.module.css`. What is here is this list's skeleton, which is the shape of THIS
 * table's rows and could not be written once.
 *
 * The tracks are `ExerciseTable.module.css`'s, restated because a skeleton must fit inside the
 * reserve it stands in and the reserve here IS the row: eight rows at `--h-ex-table-row`, the same
 * 22px inset, the same five columns. A skeleton taller than its reserve makes the card shrink when
 * the answer lands, which is the defect it was added to prevent. */

.skeletonList {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.skeletonRow {
  display: grid;
  grid-template-columns:
    44px minmax(0, 1fr) 56px minmax(0, 1.2fr) 120px 56px;
  gap: var(--space-0) var(--space-20px);
  align-items: center;
  height: var(--h-ex-table-row);
  padding: var(--space-0) var(--space-22px);
  border-bottom: var(--border-hairline) solid var(--border);
}

/* Each bar is the box its answer will stand in, so the frame the catalogue lands on changes ink and
 * nothing else. The still and the author circle keep their exact shapes; the text bars are shorter
 * than their tracks, which is what a skeleton reads as rather than a solid block. */
.skelStill {
  width: 44px;
  height: 33px;
}

.skelName {
  width: 62%;
  height: 11px;
}

.skelType {
  width: 30px;
  height: 30px;
  justify-self: center;
}

.skelPills {
  width: 78%;
  height: 22px;
}

.skelThumbs {
  width: 62px;
  height: 26px;
}

.skelAuthor {
  width: 28px;
  height: 28px;
  justify-self: center;
}
